var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.46973 20.5654C5.75098 20.5654 5.97949 20.3369 5.97949 20.0469V14.9316C6.25195 14.8613 7.06934 14.5098 8.44043 14.5098C11.6309 14.5098 13.5996 16.0918 16.6758 16.0918C17.9766 16.0918 18.5215 15.9424 19.1455 15.6523C19.6992 15.4062 20.0596 15.0195 20.0596 14.3604V5.61523C20.0596 5.19336 19.7344 4.96484 19.3037 4.96484C18.8906 4.96484 18.082 5.35156 16.5703 5.35156C13.4854 5.35156 11.5254 3.77832 8.33496 3.77832C7.03418 3.77832 6.48047 3.92773 5.85645 4.20898C5.31152 4.45508 4.95117 4.85059 4.95117 5.50977V20.0469C4.95117 20.3281 5.18848 20.5654 5.46973 20.5654ZM16.6758 15.0547C13.7051 15.0547 11.7188 13.4814 8.44043 13.4814C7.53516 13.4814 6.7002 13.5869 5.97949 13.833V5.50977C6.12012 5.20215 6.95508 4.80664 8.33496 4.80664C11.4111 4.80664 13.3975 6.37988 16.5703 6.37988C17.4668 6.37988 18.249 6.2832 19.0225 6.05469V14.3516C18.8818 14.6592 18.0557 15.0547 16.6758 15.0547Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/Flag.407830073b621c92751bd770f9b52a09.svg";
export { ForwardRef as ReactComponent };